import { Box, Heading, Text } from '@zillow/constellation-10';

export interface InsightBoxProps {
  value: number;
  metric: string;
  formatter?: (value: number) => string;
}

const defaultFormatter = (value: number) => {
  return Math.round(value).toLocaleString();
};

export const InsightBox = ({ value, metric, formatter = defaultFormatter }: InsightBoxProps) => {
  if (value <= 0) {
    return null;
  }
  return (
    <Box css={{ width: { base: '100%', md: '50%', xl: '25%' }, paddingInline: 'xs' }}>
      <Box
        css={{
          border: '1px solid',
          borderColor:
            'gray.300' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          borderRadius: 'sm',
          height: 'calc(100% - 16px)',
          marginBottom: 'md',
          padding: 'md',
        }}
      >
        <Text>{metric}</Text>
        <Box css={{ marginBlock: 'xs' }}>
          <Heading level={3}>{formatter(value)}</Heading>
        </Box>
      </Box>
    </Box>
  );
};
